import { teams } from '../types';

const INITIAL_STATE = {
    openedTab: '',
    teamsList: [],
    hasTeamsListAtEnd: false,
    inviteLinkData: {},
    teamUsersList: [],
    linkedProjects: [],
    teamsDropDownList: [],
    membersList: []
}
const teamsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case teams.SET_OPENED_TAB:
            return {
                ...state,
                openedTab: action.payload.openedTab
            }

        case teams.IS_SHOW_ADD_TEAM:
            return {
                ...state,
                isShowAddTeam: action.payload.isShowAddTeam,
                teamsMainDiv: action.payload.teamsMainDiv,
                isShowUserDetails: action.payload.isShowUserDetails,
            }

        case teams.GET_TEAMS_LIST_SUCCESS: {
            const { data, concat } = action.payload;
            let teamsList = state.teamsList;
            let hasTeamsListAtEnd = false;
            if (concat) {
                teamsList = [...teamsList, ...data];
                hasTeamsListAtEnd = data.length === 0;
            }
            else teamsList = data;
            return {
                ...state,
                teamsList: Array.from(new Map(teamsList.map(item => [item.id, item])).values()),
                hasTeamsListAtEnd
            };
        }

        case teams.GET_TEAMS_USERS_LIST_SUCCESS: {
            const { teamId, data } = action.payload;
            let teamsList = state.teamsList;

            teamsList = teamsList.map((team => {
                if (team.id === teamId && data.length > 0) {
                    let list = [...team.members, ...data];
                    list = Array.from(new Map(list.map(item => [item.id, item])).values());
                    return {
                        ...team,
                        members: list
                    }
                }
                return team;
            }))
            return {
                ...state,
                teamsList: [...teamsList]
            }
        }
        case teams.DELETE_TEAM_SUCCESS: {
            const { teamId } = action.payload;
            let teamsList = state.teamsList;
            teamsList = teamsList.filter(({ id }) => id !== teamId);

            return {
                ...state,
                teamsList
            }
        }

        case teams.EDIT_TEAM_SUCCESS: {
            const { team } = action.payload;
            let teamsList = state.teamsList;
            teamsList = teamsList.map((t) => {
                if (team.id === t.id) return { ...t, name: team.name };
                return t;
            });
            return {
                ...state,
                teamsList
            }
        };

        case teams.GENERATE_INVITE_LINK_TEAM_SUCCESS: {
            const { inviteLink, teamId } = action.payload;

            return {
                ...state,
                inviteLinkData: { ...state.inviteLinkData, [teamId]: inviteLink }
            }
        }

        case teams.ADD_USERS_TEAM_SUCCESS: {
            const { users, teamId } = action.payload;
            let teamsList = state.teamsList;
            teamsList = teamsList.map((t) => {
                if (teamId === t.id) return { ...t, members: [...t.members, ...users.map(({ user }) => ({ ...user, role: 'MEMBER' }))], members_count: t.members_count + users.length };
                return t;
            });
            return {
                ...state,
                teamsList
            }
        }

        case teams.REMOVE_TEAM_AGENT_SUCCESS: {
            const { removedMembers, teamId } = action.payload;
            let teamsList = state.teamsList;
            teamsList = teamsList.map((t) => {
                if (teamId === t.id) {
                    let newMembers = t.members.filter(({ id }) => !removedMembers.includes(id));
                    let members_count = newMembers.length;
                    return { ...t, members: newMembers, members_count };
                }
                return t;
            });
            return {
                ...state,
                teamsList
            }
        }

        case teams.GET_TEAM_USERS_LIST_SUCCESS: {
            const { data = [], query } = action.payload;

            if (!Array.isArray(data)) return state;

            const existingUsers = state.teamUsersList || [];

            const combinedUsers = query?.length > 0
                ? [...existingUsers, ...data]
                : data;

            const deduplicatedUsers = Array.from(
                new Map(combinedUsers.map(user => [user.value, user])).values()
            );

            return {
                ...state,
                teamUsersList: deduplicatedUsers,
            };
        }

        case teams.GET_LINKED_PROJECTS_SUCCESS: {
            const linkedProjects = action.payload;
            return {
                ...state,
                linkedProjects
            }
        }

        case teams.UNLINK_PROJECT_SUCCESS: {
            const { teamId, project_ids } = action.payload;
            let linkedProjects = state.linkedProjects;
            linkedProjects = linkedProjects.filter(({ id }) => !project_ids.includes(id));
            return {
                ...state,
                linkedProjects
            }
        }

        case teams.LINK_PROJECT_SUCCESS: {
            const { project_ids } = action.payload;
            let linkedProjects = state.linkedProjects;
            linkedProjects = [...linkedProjects, ...project_ids];
            return {
                ...state,
                linkedProjects
            }
        }
        case teams.GET_TEAMS_DROPDOWN_LIST_SUCCESS: {
            const incomingTeams = Array.isArray(action.payload.teams) ? action.payload.teams : [];
            const existing = state.teamsDropDownList || [];

            const map = new Map();
            [...existing, ...incomingTeams].forEach(item => {
                if (item?.value != null) map.set(item.value, item);
            });

            return {
                ...state,
                teamsDropDownList: Array.from(map.values()),
            };
        }

        case teams.CLEAR_TEAM_USERS_DROPDOWN_LIST_DATA: {
            return {
                ...state,
                teamUsersList: INITIAL_STATE.teamUsersList,
            };
        }

        case teams.CLEAR_TEAMS_DROPDOWN_LIST_DATA: {
            return {
                ...state,
                teamsDropDownList: INITIAL_STATE.teamsDropDownList,
            };
        }

        case teams.LINK_PROJECT_FAILURE:
        case teams.UNLINK_PROJECT_FAILURE:
        case teams.GET_LINKED_PROJECTS_FAILURE:
        case teams.EDIT_TEAM_FAILURE:
        case teams.GENERATE_INVITE_LINK_TEAM_FAILURE:
        case teams.ADD_USERS_TEAM_FAILURE:
        case teams.ADD_USERS_IN_TEAMS_BY_INVITATION_FAILURE:
        case teams.REMOVE_TEAM_AGENT_FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        default:
            return state
    }
}


export default teamsReducer